function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.834 24.834l2.331 2.332 2.259-1.004 19.369-19.37a2.536 2.536 0 0 0-3.586-3.585L23.414 5l2.293 2.293-1.414 1.414L22 6.414 5.838 22.576l-1.004 2.258zM23.793 1.793a4.536 4.536 0 1 1 6.414 6.414L10.773 27.641c-.13.13-.284.236-.452.31l-7.727 3.435a1.5 1.5 0 0 1-1.98-1.98l3.434-7.727a1.5 1.5 0 0 1 .31-.452L23.793 1.793z"
});

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "18d9bb822e841de52bb74a0646e14cd1.svg";
export { SvgEdit as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/edit.svg
// module id = null
// module chunks = 